// One definition of "which organisation is this admin screen about, and may the
// caller administer it" for the five Organisation screens (Overview, Members &
// Licences, Access, Identity & SSO, Encryption Keys) and Preferences. Each of
// them used to repeat this block, and ProjectFolderAccess had drifted (no
// fallback to the first membership). The role check itself is unchanged: owner
// or admin of THE ACTIVE organisation, or a platform admin. The membership is
// matched on the active org id only, so an `active_org_id` the caller is not a
// member of never borrows another membership's role.

import { useAuth } from '../contexts/AuthContext'
import type { OrgMembership } from '../types'

export interface ActiveOrg {
  orgId: string | undefined
  membership: OrgMembership | undefined
  orgName: string | undefined
  orgType: string | undefined
  isPlatformAdmin: boolean
  isOrgAdmin: boolean
  /** The auto-created solo "organisation of one" every user has (seat buying / collaborators). */
  isPersonalOrg: boolean
}

export function isPersonalOrgMembership(m: Pick<OrgMembership, 'org_id' | 'org_type'> | undefined): boolean {
  return !!m && (m.org_type === 'personal' || m.org_id.startsWith('personal-'))
}

export function useActiveOrg(): ActiveOrg {
  const { user } = useAuth()
  const orgId = user?.active_org_id || user?.org_memberships?.[0]?.org_id
  const membership = user?.org_memberships?.find((m) => m.org_id === orgId)
  const isPlatformAdmin = user?.groups?.includes('innovateflow-admin') ?? false
  const isOrgAdmin = membership?.role === 'admin' || membership?.role === 'owner' || isPlatformAdmin
  return {
    orgId,
    membership,
    orgName: membership?.org_name,
    orgType: membership?.org_type,
    isPlatformAdmin,
    isOrgAdmin,
    isPersonalOrg: isPersonalOrgMembership(membership),
  }
}
